import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { termsConditionsList } from './constants';

const TermsAndConditions = () => {

   useEffect(() => {
      const element = document.getElementById('landingPage')
      element.scrollIntoView({
         block: "start",
         inline: "nearest"
      });
   }, [])

   return (
      <>
         <div id="landingPage" className='faq-header'>
            <Navbar />
         </div >
         <main className='container details-section'>
            <div className='details-wrap pb-5'>
               <h2>
                  Terms Of Use
               </h2>
               <p>
                  This document is an electronic record in terms of Information Technology
                  Act, 2000 and rules there under as applicable and the amended provisions
                  pertaining to electronic records in various statutes as amended by the
                  Information Technology Act, 2000. This document is published in
                  accordance with the provisions of Rule 3 (1) of the Information Technology
                  (Intermediaries guidelines) Rules, 2011 that require publishing the rules
                  and regulations, privacy policy and Terms of Use for access or usage of
                  www.enjoyfresh.com website (“Website”) and enjoyfresh application
                  (“Platform”) for mobile and handheld devices.
               </p>
               <p>
                  We, Enjoyfresh software solutions Pvt Ltd, are operating this Website and
                  Application as an intermediary as contemplated under the rules of the
                  Information Technology (Intermediaries Guidelines) Rules, 2011.
               </p>
               <p>
                  By merely using, browsing, accessing, downloading, this webpage
                  <a href='www.enjoyfresh.com' target='_blank'> www.enjoyfresh.com</a> and its application (“Platform”), you shall be deemed
                  as a “User” and are bound by these Terms of Use. In case you do not agree
                  with these Terms of Use, you may not browse, access, download or use this
                  webpage or the Platform or using the Platform services (“Services”). We
                  facilitate services as contemplated hereunder to you who register with us or
                  access our platform.
               </p>
               <p>
                  You understand and agree that by clicking on “I agree” you are accepting to
                  these Terms of Use.
               </p>

               {
                  termsConditionsList.map((termsConditions) => {
                     return <div key={termsConditions.no}>
                        <h6>{termsConditions.question}</h6>
                        {
                           termsConditions.answer && termsConditions.answer.length > 0 ? (

                              termsConditions.answer.map((termsConditionsItem, termsConditionsItemIndex) => {
                                 return <p key={termsConditionsItemIndex}>{termsConditionsItem}</p>
                              })

                           ) : ""
                        }
                        {
                           termsConditions.list && termsConditions.list.length > 0 ? (
                              <ul>
                                 {termsConditions.list.map((privacyPolicyListItem, privacyPolicyListItemIndex) => {
                                    return <li key={privacyPolicyListItemIndex}>{privacyPolicyListItem}</li>
                                 })}
                              </ul>
                           ) : ""
                        }
                        {
                           termsConditions.answer2 && termsConditions.answer2.length > 0 ? (

                              termsConditions.answer2.map((termsConditionsItem, termsConditionsItemIndex) => {
                                 return <p key={termsConditionsItemIndex}>{termsConditionsItem}</p>
                              })

                           ) : ""
                        }
                     </div>
                  })
               }
            </div>
         </main>
         <Footer />
      </>
   )
};

export default TermsAndConditions;
